import React, { createContext, useContext, useReducer } from 'react';

const CartContext = createContext();

const cartReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_ITEM': {
      const existingItem = state.items.find(
        item =>
          item.productId === action.payload.productId &&
          item.weight === action.payload.weight
      );

      if (existingItem) {
        return {
          ...state,
          items: state.items.map(item =>
            item.productId === action.payload.productId &&
            item.weight === action.payload.weight
              ? { ...item, quantity: item.quantity + 1 }
              : item
          )
        };
      }

      return { ...state, items: [...state.items, action.payload] };
    }

    case 'UPDATE_QUANTITY':
      return {
        ...state,
        items: state.items.map(item =>
          item.productId === action.payload.productId &&
          item.weight === action.payload.weight
            ? { ...item, quantity: action.payload.quantity }
            : item
        )
      };

    case 'REMOVE_ITEM':
      return {
        ...state,
        items: state.items.filter(
          item =>
            !(
              item.productId === action.payload.productId &&
              item.weight === action.payload.weight
            )
        )
      };

    case 'CLEAR_CART':
      return { ...state, items: [] };

    default:
      return state;
  }
};

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, { items: [] });

  const addToCart = (product, priceData) => {
  if (!product || !priceData) {
    console.error('addToCart called with invalid data', {
      product,
      priceData
    });
    return;
  }

  dispatch({
    type: 'ADD_ITEM',
    payload: {
      productId: product._id,
      name: product.name,
      image: product.image,
      weight: priceData.weight,
      price: priceData.price,
      originalPrice: priceData.originalPrice || null,
      quantity: 1
    }
  });
};


  const updateQuantity = (productId, weight, quantity) => {
    if (quantity <= 0) {
      dispatch({
        type: 'REMOVE_ITEM',
        payload: { productId, weight }
      });
    } else {
      dispatch({
        type: 'UPDATE_QUANTITY',
        payload: { productId, weight, quantity }
      });
    }
  };

  const clearCart = () => {
    dispatch({ type: 'CLEAR_CART' });
  };

  const getTotalPrice = () =>
    state.items.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );

  const getTotalItems = () =>
    state.items.reduce((total, item) => total + item.quantity, 0);

  return (
    <CartContext.Provider
      value={{
        items: state.items,
        addToCart,
        updateQuantity,
        clearCart,
        getTotalPrice,
        getTotalItems
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
